import { site } from "../content";
import { WaCta } from "./WaCta";
import { Reveal } from "./Reveal";

export default function FinalCTA() {
  return (
    <section id="contato" data-testid="final-cta-section" className="relative overflow-x-clip py-28 md:py-44">
      <div className="spotlight-gold pointer-events-none absolute inset-0" aria-hidden="true" />
      <div className="relative mx-auto max-w-5xl px-6 text-center md:px-12">
        <Reveal>
          <p className="font-serif text-xl italic text-gold md:text-2xl">O próximo capítulo</p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2
            data-testid="final-cta-heading"
            className="mt-6 font-display text-4xl font-black uppercase leading-[1.02] tracking-tight text-bone sm:text-5xl lg:text-6xl"
          >
            Sua barbearia evoluiu.
            <span className="text-outline-gold mt-2 block">
              O preparo das toalhas
            </span>
            <span className="block">também pode evoluir.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mx-auto mt-8 max-w-xl text-base leading-relaxed text-bone/60 md:text-lg">
            Mais praticidade para o profissional. Mais organização para a
            barbearia. Uma experiência diferenciada para o cliente.
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <div className="mt-12 flex flex-col items-center gap-5">
            <WaCta
              message={site.messages.final}
              location="final_cta"
              label="Quero meu Barber Steamer"
              testId="final-cta-btn"
              className="px-10 py-5 text-base"
            />
            <p className="text-sm text-bone/45">
              Fale diretamente com nossa equipe pelo WhatsApp.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
